import React, { useState } from "react";
import DialogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Plus } from "../../svgs/plus.svg";
import { ReactComponent as Minus } from "../../svgs/minus.svg";
import { formatBalance } from "../../../utils/helper/wallet";
import getSymbolFromCurrency from "currency-symbol-map";
import Input from "../../atoms/Input";

const WithdrawMoneyDialog = ({
  open,
  onWithdraw,
  onCancel,
  balance,
  currency,
  registerAmount,
}) => {
  const [money, setMoney] = useState(0);

  const withdrawHandler = async () => {
    registerAmount(money);
    setMoney(0);
    onWithdraw();
  };
  return (
    <DialogBox open={open} width={425} onCancel={onCancel}>
      <h3 className="text-xl font-medium w-fit mx-auto pt-7">Withdraw</h3>
      <hr className="border-b-[1px] text-[#4B4B4B] mt-4 mb-6" />
      <div className="text-xl font-normal w-fit mx-auto">
        Withdrawable amount -{" "}
        <b className="font-bold">
          {"$"} {formatBalance(Number(balance))}
        </b>
      </div>
      <hr className="border-b-[1px] text-[#4B4B4B] mt-4 mb-5 mx-4" />
      <p className="w-fit mx-auto text-xl font-medium text-[#252525] opacity-60">
        Withdraw
      </p>
      <div className="flex justify-center">
        <div className="w-[180px] divide-x-[1px] divide-blue-800 h-[42px] mt-5 mb-4 border-[1px] border-blue-800 rounded-xl flex">
          <div
            className="w-[15%] flex justify-center items-center cursor-pointer"
            onClick={() => {
              if (money === 0) return;
              setMoney(money - 1);
            }}
          >
            <div className=" bg-blue-300 w-3 h-3 flex justify-center items-center font-bold text-blue-800 rounded">
              <Minus className="w-4 h-4" />
            </div>
          </div>
          <div className="w-[70%] text-xl font-normal flex justify-center items-center">
            <span className="mr-2">{"$"}</span>
            <Input
              type={"number"}
              value={money}
              className={"w-24 ml-1"}
              onChange={(e) => {
                let value = Number(e.target.value || 0);
                if (e.target.value === "") setMoney("");
                else if (value >= 0) setMoney(value);
              }}
            />
          </div>
          <div
            className="w-[15%] flex justify-center items-center cursor-pointer"
            onClick={() => setMoney(money + 1)}
          >
            <div className=" bg-blue-300 w-3 h-3 flex justify-center items-center font-bold text-blue-800 rounded">
              <Plus className="w-4 h-4" />
            </div>
          </div>
        </div>
      </div>

      {money > balance && (
        <p className="px-4 text-red-600 text-center">
          Enter amount less than or equal to the withdrawable amount of{" "}
          {getSymbolFromCurrency(currency)} {formatBalance(Number(balance))}
        </p>
      )}

      <div className="flex justify-center mt-8 pb-11">
        <Button
          disabled={money > balance || money === 0}
          className={
            "text-white bg-blue-800 w-[125px] h-[40px] rounded-lg text-sm font-bold flex justify-center items-center"
          }
          onClick={withdrawHandler}
        >
          Withdraw
        </Button>
      </div>
    </DialogBox>
  );
};

export default WithdrawMoneyDialog;
